<template>
  <div class="about-sns-buttons">
    <div class="about-sns-buttons__icons">
      <a href="https://twitter.com/_giftee">
        <TwitterImage class="about-sns-buttons__icon" />
      </a>
      <a href="https://www.facebook.com/giftee.co/">
        <FacebookImage class="about-sns-buttons__icon" />
      </a>
      <a href="https://www.instagram.com/_giftee">
        <img
          src="../../../../../../images/abouts/icons/glyph-logo_May2016.png"
          alt="instagram"
          class="about-sns-buttons__icon"
        />
      </a>
    </div>
  </div>
</template>

<script>
import FacebookImage from '../../../atoms/svg_icons/FacebookImage'
import TwitterImage from '../../../atoms/svg_icons/TwitterImage'
export default {
  components: { FacebookImage, TwitterImage }
}
</script>

<style lang="scss" scoped>
.about-sns-buttons {
  background-color: $gray-3;

  &__icons {
    margin: auto;
    display: flex;
    justify-content: space-between;
    width: 208px;

    @media all and (max-width: $pc-width  - 1) {
      width: 152px;
    }
  }

  &__icon {
    @extend %hover-common;
    width: 32px;
    height: 32px;

    @media all and (max-width: $pc-width  - 1) {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
